import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

type WeatherStatValueProps = {
  value: number | undefined;
  i18nKey: string;
  transValues: Record<string, string | number>;
  valuePlaceholder: string | number;
  unitPlaceholder: string;
  prefix?: ReactNode;
  indicatorColor?: string;
};

export const WeatherStatValue = (props: WeatherStatValueProps): JSX.Element => {
  const {
    value,
    i18nKey,
    transValues,
    valuePlaceholder,
    unitPlaceholder,
    prefix,
    indicatorColor,
  } = props;

  if (typeof value !== 'number') {
    return <>-</>;
  }

  return (
    <Stack component="span" direction="row" spacing={1} alignItems="center">
      {indicatorColor && (
        <Box
          sx={{
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: indicatorColor,
            border: (theme) => `1.5px solid ${theme.palette.text.primary}`,
          }}
        />
      )}
      <Stack
        component="span"
        direction="row"
        spacing={0.25}
        alignItems="center"
      >
        {prefix}
        <Trans i18nKey={i18nKey} values={transValues}>
          <Typography component="span" sx={{ fontWeight: 'fontWeightBold' }}>
            {/* Placeholder values must be strings */}
            {valuePlaceholder.toString()}
          </Typography>
          <Typography component="span" variant="subtitle1">
            {unitPlaceholder}
          </Typography>
        </Trans>
      </Stack>
    </Stack>
  );
};
